/**
 * Checks whether the given `value` is a `Instance`.
 * @param  {Object|Instance|null}  value
 * @returns {Boolean}
 */
export default function isInstanceReduxUtil (value) {
  return (
    typeof value?.data !==
    'undefined' &&
    typeof value?.changed !==
    'undefined' &&
    typeof value?.className !==
    'undefined' &&
    typeof value?.status !==
    'undefined' &&
    typeof value?.validation !==
    'undefined'
  )
}
